<template>
   <v-dialog
     v-model="showDialog"
     max-width="290px"
     persistent
   >
    <v-card class="pa-3">
      <v-card-title class="pb-5 conformation_dialog">
        {{ textConfirmation }}
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" dark @click="cancel">{{ $t('cancel') }}</v-btn>
        <v-btn color="green darken-1" dark @click="save">{{ $t('save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import i18n from '../i18n';

  export default {
    props: {
      confirmDialogShow: {
        required: true,
        type: Boolean
      },
      textConfirmation: {
        required: false,
        type: String,
        default: i18n.t('confirmDialog.defaultMessage')
      }
    },
    created() {
      this.showDialog = this.confirmDialogShow
    },
    data() {
      return {
        showDialog: false
      }
    },
    methods: {
      cancel() {
        this.$emit('confirm-dialog-close')
        this.showDialog = false
      },
      save() {
        this.$emit('confirm-dialog-save')
        this.showDialog = false
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>